// src/features/staff/pages/ProfilePage/components/RolesCard.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Alert,
} from '@mui/material';
import {
  VpnKey as VpnKeyIcon,
} from '@mui/icons-material';

export default function RolesCard({ profileData }) {
  const { t } = useTranslation(['staff']);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('staff:profile.assigned_roles')}
        </Typography>

        {profileData.roles && profileData.roles.length > 0 ? (
          <List>
            {profileData.roles.map((role) => (
              <ListItem key={role.role_id} divider>
                <ListItemIcon>
                  <Avatar sx={{ width: 36, height: 36, bgcolor: 'primary.main' }}>
                    <VpnKeyIcon fontSize="small" />
                  </Avatar>
                </ListItemIcon>
                <ListItemText
                  // Custom Typography children: render slots as divs, not <p>, to keep valid nesting
                  slotProps={{ primary: { component: 'div' }, secondary: { component: 'div' } }}
                  primary={
                    <Typography variant="body1" fontWeight="medium">
                      {role.name}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" color="text.secondary">
                      {role.description || t('staff:profile.no_description')}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Alert severity="info">
            {t('staff:profile.no_roles_assigned')}
          </Alert>
        )}
      </CardContent>
    </Card>
  );
}